/* Progressive enhancement: data comes from the editable Shopify appointment blocks. */
(() => {
  function update(card, announce = false) {
    let option = card.querySelector('[data-fitting-option]:checked');
    if (!option) {
      option = card.querySelector('[data-fitting-option]');
      if (option) option.checked = true;
    }
    if (!option) return;
    const data = option.dataset;
    const link = card.querySelector('[data-fitting-link]');
    link.hidden = !data.url;
    if (data.url) link.href = data.url;
    else link.removeAttribute('href');
    link.setAttribute('aria-label', `${link.textContent.trim()} : ${data.label} (nouvel onglet)`);
    if (announce) {
      card.querySelector('[data-fitting-announcement]').textContent =
        [data.label, card.querySelector('[data-fitting-price]')?.textContent,
          card.querySelector('[data-fitting-duration]')?.textContent].filter(Boolean).join('. ');
    }
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-fitting-card]').forEach((card) => {
      if (card.dataset.initialized) return;
      card.dataset.initialized = 'true';
      card.querySelectorAll('[data-fitting-option]').forEach((option) => {
        option.name = card.dataset.fittingName;
      });
      update(card);
      card.addEventListener('change', (event) => {
        if (event.target.matches('[data-fitting-option]')) update(card, true);
      });
    });
    // The native carousel already handles hover, visibility and reduced motion.
    // Pause it when keyboard users enter it; restart only via its explicit Play control.
    root.querySelectorAll('[id$="__booking_intro"] slideshow-component').forEach((carousel) => {
      if (carousel.dataset.fittingFocus) return;
      carousel.dataset.fittingFocus = 'true';
      carousel.addEventListener('focusin', () => carousel.pause?.());
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const option = event.target.closest('.fitting-choice')?.querySelector('[data-fitting-option]');
    if (!option) return;
    option.checked = true;
    update(option.closest('[data-fitting-card]'), true);
  });
})();
